import request from '@/utils/requestMain'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function getInfo(token, companyId) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token, companyId }
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function homeStatistics() {
  return request({
    url: '/user/relateOfMe',
    method: 'get'
  })
}
